/* Solvik — navigation de la visionneuse de photos.
 *
 * Dawn ouvre bien un dialogue plein écran au clic sur une photo, mais il y
 * empile toutes les images et fait défiler jusqu'à celle qu'on a cliquée.
 * Ce fichier en fait une visionneuse : une photo à la fois, deux flèches,
 * un compteur, les touches du clavier.
 *
 * On ne remplace pas <product-modal> : son ouverture, son piège à focus et
 * sa fermeture sont ceux de Dawn et fonctionnent. On se greffe sur la classe
 * `active` qu'il pose déjà sur la photo courante — c'est le seul point de
 * contact, et il est stable.
 *
 * Sans ce fichier, les boutons restent `hidden` et la page garde le
 * comportement d'origine.
 */

(function () {
  'use strict';

  function cabler(modal) {
    var contenu = modal.querySelector('[role="document"]');
    var precedent = modal.querySelector('[data-sv-galerie-precedent]');
    var suivant = modal.querySelector('[data-sv-galerie-suivant]');
    var compteur = modal.querySelector('[data-sv-galerie-compteur]');
    if (!contenu || !precedent || !suivant) return;

    function photos() {
      return Array.prototype.slice.call(contenu.querySelectorAll('[data-media-id]'));
    }

    function rafraichir() {
      var liste = photos();
      var i = liste.findIndex(function (m) { return m.classList.contains('active'); });
      if (i === -1) return;

      /* Une seule photo : ni flèches ni compteur. Le dialogue reste utile,
         il montre l'image en grand. */
      var plusieurs = liste.length > 1;
      precedent.hidden = !plusieurs;
      suivant.hidden = !plusieurs;
      if (compteur) {
        compteur.hidden = !plusieurs;
        compteur.textContent = (i + 1) + ' / ' + liste.length;
      }
    }

    function aller(pas) {
      var liste = photos();
      if (liste.length < 2) return;
      var i = liste.findIndex(function (m) { return m.classList.contains('active'); });
      if (i === -1) i = 0;

      /* La visionneuse boucle : arrivé à la dernière, la flèche suivante
         ramène à la première. Une flèche désactivée en bout de course fait
         croire que le bouton est cassé. */
      var j = (i + pas + liste.length) % liste.length;
      liste[i].classList.remove('active');
      liste[j].classList.add('active');

      var image = liste[j].querySelector('img');
      if (image) image.focus({ preventScroll: true });
      rafraichir();
    }

    precedent.addEventListener('click', function () { aller(-1); });
    suivant.addEventListener('click', function () { aller(1); });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); aller(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); aller(1); }
    });

    /* Dawn pose `active` au moment de l'ouverture, après notre câblage, et
       la déplace quand on rouvre sur une autre photo. On observe plutôt que
       de deviner le moment. */
    new MutationObserver(rafraichir).observe(contenu, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    rafraichir();
  }

  function demarrer() {
    Array.prototype.forEach.call(document.querySelectorAll('product-modal'), cabler);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
